import { render, staticRenderFns } from "./EducationalInstitute.vue?vue&type=template&id=7cccc139"
import script from "./EducationalInstitute.vue?vue&type=script&lang=js"
export * from "./EducationalInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports